import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ReservationAvailabilityEffect } from './reservation-availability.effect';
import { reservationAvailabilityReducer } from './reservation-availability.reducer';
import { RESERVATION_AVAILABILITY_STORE_NAME, ReservationAvailabilityState } from './reservation-availability.state';

/** Token of the ReservationAvailability reducer */
export const RESERVATION_AVAILABILITY_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<ReservationAvailabilityState, Action>
>('Feature ReservationAvailability Reducer');

/** Provide default reducer for ReservationAvailability store */
export function getDefaultReservationAvailabilityReducer() {
  return reservationAvailabilityReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(RESERVATION_AVAILABILITY_STORE_NAME, RESERVATION_AVAILABILITY_REDUCER_TOKEN),
    EffectsModule.forFeature([ReservationAvailabilityEffect]),
  ],
  providers: [
    { provide: RESERVATION_AVAILABILITY_REDUCER_TOKEN, useFactory: getDefaultReservationAvailabilityReducer },
  ],
})
export class ReservationAvailabilityStoreModule {
  public static forRoot<T extends ReservationAvailabilityState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ReservationAvailabilityStoreModule> {
    return {
      ngModule: ReservationAvailabilityStoreModule,
      providers: [{ provide: RESERVATION_AVAILABILITY_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
